var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Timeline',{attrs:{"title":_vm.$t('nav.timeline'),"timeline":_vm.timeline,"timeline-name":'friends'}})}
var staticRenderFns = []
export { render, staticRenderFns }